import { useEffect, useState } from "react";
import api from "@/lib/api";
import { Flame, AlertTriangle } from "lucide-react";
import { Link } from "react-router-dom";

export default function StreakReminder() {
  const [s, setS] = useState(null);
  useEffect(() => { api.get("/streak/status").then((r) => setS(r.data)).catch(() => {}); }, []);
  if (!s || !s.at_risk) return null;
  return (
    <div data-testid="streak-reminder" className="nb-card p-5 bg-[var(--sun)] flex items-center justify-between gap-3 flex-wrap">
      <div className="flex items-center gap-3">
        <div className="w-12 h-12 rounded-xl bg-white border-2 border-black flex items-center justify-center">
          <Flame className="w-6 h-6 text-[var(--coral)]" />
        </div>
        <div>
          <div className="flex items-center gap-2">
            <AlertTriangle className="w-4 h-4" />
            <span className="text-xs uppercase font-bold">Streak alert</span>
          </div>
          <div className="text-lg font-extrabold">
            Your {s.streak}-day streak needs 1 quick session today
          </div>
          <p className="text-xs text-neutral-700">Just one question keeps the fire going. You've got this.</p>
        </div>
      </div>
      <Link data-testid="streak-cta" to="/practice" className="nb-btn">Save my streak 🔥</Link>
    </div>
  );
}
